import React, { Component } from 'react';
import './Footer.css';
import { Parallax } from 'react-scroll-parallax';
import su from './su.png';
import akce from './akce.png';

class Footer extends Component {
  render() {
    return (
    <div>
      <div className="footer">
	      <img src={su} alt="su" className="sutb"/>
		  <img src={akce} alt="akce" />
      </div>
    </div>
    );
  }
}

export default Footer;